import React from "react"
import { FormikProps } from "formik/dist/types"

export const NdfSubmitActions = ({ helpers, setSubmitAction }: { helpers: FormikProps<any>, setSubmitAction: any }) => (
     <div className="text-center d-flex flex-sm-row flex-column justify-content-end">
          <button className={"btn btn-sm btn-primary me-2 mb-sm-0 mb-2"} type={"submit"} disabled={helpers.isSubmitting} onClick={() => setSubmitAction("close")}>
               {!helpers.isSubmitting ? (
                    <>
                         Finaliser l'ajout <i className={"fas fa-check-circle align-middle"} />
                    </>
               ) : (
                    <span className="indicator-progress" style={{ display: "block" }}>
                         Ajout en cours
                         <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
               )}
          </button>
     </div>
)
